// react components

//ReactEcharts
import ReactEcharts from "echarts-for-react";

// react-router-dom components

// mui components

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import { AppendStatsToCharts } from "../../../utils/AppendStatsToCharts";

function VerticalBarGraph({ data = [] }) {
    const reversedData = [...data].reverse();
    const seriesData = AppendStatsToCharts(reversedData);

    const labels = reversedData.map((item) => item.title);

    const seriesBars = [
        {
            data: seriesData,
            type: "bar",
            barWidth: "80%",
            barGap: "-20%",
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                },
            },
        },
    ];

    const additionalLegends = labels.map((label) => ({
        name: label,
        type: "bar",
        data: [],
        itemStyle: {
            color: "#5470C6",
        },
    }));

    const series = seriesBars.concat(additionalLegends);

    // Define chart options
    const option = {
        tooltip: {
            trigger: "item",
            confine: true,
            formatter: function (params) {
                let tooltipText = `<div style="text-align: left;">${params.name}: ${params.value}`;
                if (params.data.details) {
                    tooltipText += params.data.details.map((detail) => `<br/>${detail.name} : <span style={{fontWeight: 600}}>${detail.value}</span>`).join("");
                }
                tooltipText += `</div>`;
                return tooltipText;
            },
            textStyle: {
                fontSize: 12,
            },
        },
        legend: {
            top: "top",
            type: "scroll",
            selectedMode: false,
        },
        grid: {
            left: "10%",
            top: "20%",
            right: "5%",
            bottom: "28%",
        },
        xAxis: {
            type: "category",
            data: labels,
            axisLabel: {
                rotate: 45,
                width: 80,
                overflow: "truncate",
                elepsis: "...",
                lineHeight: 14,
                padding: [0, 10, 0, 10],
                fontFamily: "poppinsregular",
            },
        },
        yAxis: {
            type: "value",
        },
        dataZoom: [
            {
                type: "inside", // allows mouse/touch zoom
                start: 0,
                end: 4000,
            },
        ],
        series: series,
    };

    return (
        <div
            style={{
                overflow: "auto",
            }}
        >
            <ReactEcharts
                option={option}
                style={{
                    minWidth: "500px",
                    height: "400px",
                }}
                opts={{
                    renderer: "svg",
                }}
            />
        </div>
    );
}

// Typechecking props for the VerticalBarGraph
VerticalBarGraph.propTypes = {
    data: PropTypes.array,
};

export default VerticalBarGraph;
